<script>
export default {
    methods: {
        formatNumber (valor) {
            if (typeof valor === 'string') {
                return valor;
            }

            return new Intl.NumberFormat('pt-br').format(valor);
        },
        goToLink (item) {
            if (item !== '') {
                document.location.href = item;
            }
        },
        bannerClick (link) {
            if (link !== '') {
                document.location.href = link;
            }
        },
        abrirLinkMarca (link) {
            if (link !== '') {
                document.location.href = link;
            }
        },
        formatCurrency (valor) {
            return new Intl.NumberFormat('pt-br', { style: 'currency',
                currency: 'BRL' }).format(valor);
        },
        formatShortCurrency (valor) {
            return new Intl.NumberFormat('pt-br', { style: 'currency',
                currency: 'BRL', notation: 'compact'}).format(valor);
        }
    }
};
</script>
